<template>
  <modal titulo="Anexar Documentos">
    <anexos-wrapper 
      nome="Anexos" 
      :entidade="entidade" 
      :id="id" 
      :permitir-edicao="permitirEdicao" 
      :permite-excluir-anexo="permiteExcluirAnexo" 
      :permite-ia="permiteIa" 
      :permite-tags="permiteTags"
      :accept="accept"
      :extensions="extensions"
    />
  </modal>
</template>

<script>

import {defineComponent} from "vue";
import Modal from "@/components/Modal.vue";
import AnexosWrapper from "@/components/Anexos/AnexosWrapper.vue";
import EventBus from "@/commons/EventBus";

export default defineComponent({
  components: {AnexosWrapper, Modal},
  props: {
    id: String,
    entidade: String,
    permitirEdicao: Boolean,
    permiteExcluirAnexo: {type: Boolean, default: true},
    permiteIa: {type: Boolean, default: true},
    permiteTags: {type: Boolean, default: true},
    accept: {type: String, default: null},
    extensions: {type: String, default: null},
  },

  beforeDestroy() {
    EventBus.$emit('anexos-modal-closed');
  }
})
</script>

<style>

</style>
